import { motion } from "framer-motion";
import { fadeUp, fadeUpChild, stagger, viewportOnce } from "./anim";
import { profile, metrics } from "@/data/resume";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about"
      className="relative mx-auto max-w-[1500px] px-6 py-28 md:px-12 md:py-40"
    >
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className="mb-16 flex items-center gap-4"
      >
        <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-[#9A7526]">
          (01) — About
        </span>
      </motion.div>

      <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="lg:col-span-7"
        >
          <h2 className="font-display text-3xl font-light leading-[1.15] tracking-tight text-[#1A1A18] md:text-5xl">
            I turn product adoption into{" "}
            <span className="text-[#9A7526]">measurable business value</span> —
            retention, expansion and advocacy at enterprise scale.
          </h2>
          <p className="mt-10 max-w-2xl font-body text-base font-light leading-relaxed text-[#6E6D66] md:text-lg">
            {profile.intro}
          </p>
          <p className="mt-6 max-w-2xl font-body text-base font-light leading-relaxed text-[#6E6D66] md:text-lg">
            {profile.aboutLong}
          </p>
        </motion.div>

        {/* Metrics bento */}
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-2 gap-px self-start overflow-hidden border border-black/10 bg-black/10 lg:col-span-5"
        >
          {metrics.map((m) => (
            <motion.div
              key={m.label}
              variants={fadeUpChild}
              data-testid={`metric-${m.value}`}
              className="bg-[#FFFFFF] p-8 md:p-10"
            >
              <div className="font-display text-4xl font-light text-[#1A1A18] md:text-6xl">
                {m.value}
              </div>
              <div className="mt-3 font-mono-x text-[11px] uppercase tracking-[0.2em] text-[#6E6D66]">
                {m.label}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
